import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_OPERADOR = "identity-service/identity/persons";

const RESOURCES = {
	LIST_OPERADORES: (id) => `${BASE_OPERADOR}/organizations/${id}`,

	LIST_CLIENT_OPERADORES_PAGINATED: (page, searchText, clientID, orderBy) =>
		`${BASE_OPERADOR}/organizations/${clientID}/paginated?page=${page}&limit=8&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,

	DELETE_OPERADOR: (id) => `${BASE_OPERADOR}/${id}`,

	GET: (id) => `${BASE_OPERADOR}/${id}`,

	GET_PERSON_SHIFTS: (id) => `${BASE_OPERADOR}/${id}/shifts`,
};

class OperadorService {
	static async listOperadoresByClientId(clientId) {
		try {
			return await axios.get(RESOURCES.LIST_OPERADORES(clientId));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar operadores",
			});
			return error.response;
		}
	}

	static async listClientOperadoresPaginated(
		page,
		searchText,
		clientID,
		orderBy,
	) {
		try {
			return await axios.get(
				RESOURCES.LIST_CLIENT_OPERADORES_PAGINATED(
					page,
					searchText,
					clientID,
					orderBy,
				),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar operadores",
			});
			return error.response;
		}
	}

	static async createOperador(payload) {
		try {
			const response = await axios.post(BASE_OPERADOR, payload);
			ResponseAlerts({
				response: response,
				successMessage: "Operador criado com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao criar operador",
			});
			return error.response;
		}
	}

	static async getOperador(id) {
		try {
			const response = await axios.get(RESOURCES.DELETE_OPERADOR(id));
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao obter operador",
			});
			return error.response;
		}
	}

	static async deleteOperador(id) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_OPERADOR(id));
			ResponseAlerts({
				response: response,
				successMessage: "Operador excluído com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao excluir operador",
			});
			return error.response;
		}
	}

	static async getPersonShifts(personId) {
		try {
			return await axios.get(RESOURCES.GET_PERSON_SHIFTS(personId));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter os turnos",
			});
			return error.response;
		}
	}

	static async updateOperador(id, payload) {
		return await axios
			.put(BASE_OPERADOR + "/" + id, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Operador atualizado com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: "Erro ao atualizar operador",
				});
				return error.response;
			});
	}
}

export default OperadorService;
